<template>
  <v-card>
    <v-card-title>Cargar menú a {{ this.restaurant.name }}</v-card-title>
    <v-card-subtitle
      >Cargue un archivo excel con el menú de su restaurant</v-card-subtitle
    >
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <h3>Paso 1 - Seleccione archivo</h3>
        <v-file-input
          class="my-2"
          label="Subir archivo"
          hide-details
          outlined
          dense
          @change="onFileUpload"
        ></v-file-input>
        <h3>Paso 2 - Indique en qué columna están los siguientes campos</h3>
        <v-row>
          <v-col>
            <span>Nombre</span>
            <v-text-field
              label="Letra"
              v-model="column.name"
              :rules="$rule('required|min1|max1')"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col>
            <span>Descripción</span>
            <v-text-field
              label="Letra"
              v-model="column.description"
              :rules="$rule('required|min1|max1')"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col>
            <span>Precios</span>
            <v-text-field
              label="Letra"
              v-model="column.price"
              :rules="$rule('required|min1|max1')"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <v-col>
            <span>Categoría</span>
            <v-text-field
              label="Letra"
              v-model="column.category"
              :rules="$rule('required|min1|max1')"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <h3>Paso 3 - Indique en qué fila comienzan los datos</h3>
        <v-row align="center">
          <v-col cols="auto">
            <span>Comienza desde la fila</span>
          </v-col>
          <v-col cols="auto">
            <v-text-field
              label="N° de Fila"
              v-model="startRow"
              :rules="$rule('required|number')"
              style="width: 100px"
              type="number"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <h3>Paso 4 - Indique la hoja en la que se encuentran los datos</h3>
        <v-row align="center">
          <v-col cols="auto">
            <span>Hoja</span>
          </v-col>
          <v-col cols="auto">
            <v-text-field
              label="N° de Hoja"
              v-model="sheetNumber"
              :rules="$rule('required|number')"
              style="width: 125px"
              type="number"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <h3>Paso 5 - Previsualizar menú</h3>
        <v-btn
          color="primary"
          class="mt-2"
          @click="showMenuPreview"
          :disabled="!file || !valid"
          >Previsualizar</v-btn
        >
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text :disabled="loading" @click="$emit('close')">Cancelar</v-btn>
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="!previewed || !file || !valid"
        >Subir</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import readXlsxFile from 'read-excel-file';
  import UploadMenuPreviewModal from './UploadMenuPreviewModal.vue';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import { vueData } from '../../VueData';
  import ItemsService from '../../api/services/items.service';
  import { xlsToItems } from '../../lib/XlsToItems';
  import { AlertType } from '../../interfaces/IAlert';

  @Component()
  export default class UploadMenuModal extends Vue {
    @Prop() restaurant: IRestaurant;
    itemsService = new ItemsService();

    loading = false;
    valid = false;
    previewed = false;
    column = {
      name: null,
      description: null,
      price: null,
      category: null,
    };
    startRow: string = null;
    sheetNumber: string = null;
    file = null;

    onFileUpload(file: File) {
      this.file = file;
    }

    async showMenuPreview() {
      const rows = await readXlsxFile(this.file, {
        sheet: parseInt(this.sheetNumber),
      });
      console.log(rows);

      this.$modal.show(
        UploadMenuPreviewModal,
        {
          title: 'Previsualización de Menú',
          message: 'Esta es la previsualización de su menú',
          rows: rows,
          startRow: this.startRow,
          column: this.column,
        },
        {
          name: 'preview-menu',
          classes: 'dialog--height-limit',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
          width: 1000,
          clickToClose: false,
        },
        {
          confirm: () => (this.previewed = true),
        }
      );
    }

    async created() {}

    async submit() {
      this.loading = true;

      try {
        const rows = await readXlsxFile(this.file, {
          sheet: parseInt(this.sheetNumber),
        });

        const items = xlsToItems(rows, this.column, this.startRow);
        await this.itemsService.importBeta2(this.restaurant.id, items);
        vueData.addAlert('Items cargados correctamente', AlertType.Success);
        this.$emit('close');
      } catch (e) {
        console.error(e);
        vueData.serverError(e);
      } finally {
        this.loading = false;
      }
    }
  }
</script>

<style scoped lang="scss">
  .upload-menu-style {
    ::v-deep .v-treeview-node__root {
      min-height: 30px !important;
    }
  }
</style>
